import { useEffect } from 'react';

// A strip across the top of every page, and "[DEV]" in the tab title, when
// running on the Vite dev server, so testers never mistake dev (a copy of
// the real data) for the live site. Production images are built by
// `vite build`, where import.meta.env.DEV is false, so they never show it.
const PREFIX = '[DEV] ';

export default function DevBanner() {
  useEffect(() => {
    if (!import.meta.env.DEV) return undefined;
    // Pages set their own titles, so re-add the prefix whenever it changes.
    const mark = () => {
      if (!document.title.startsWith(PREFIX)) document.title = PREFIX + document.title;
    };
    mark();
    const title = document.querySelector('title');
    if (!title) return undefined;
    const observer = new MutationObserver(mark);
    observer.observe(title, { childList: true });
    return () => observer.disconnect();
  }, []);

  if (!import.meta.env.DEV) return null;
  return (
    <div className="dev-banner" role="note">
      DEVELOPMENT COPY: not the real NHCA site. Entries and logins here are for testing only.
    </div>
  );
}
